import React from 'react';
import classnames from 'classnames';
import classes from './design-attachments.scss';
class DesignAttachmentsForm extends React.Component {
  constructor(props) {
    super(props);
    this.upload = this.upload.bind(this);
    this.state = {
      file: ''
    };
  }
  upload(e) {
    e.preventDefault();
    const {
      onFileAdd
    } = this.props;
    const file = e.target.files[0];
    onFileAdd(file);
    this.setState({
      file: ''
    });
  }
  render() {
    const {
      isAttachmentPresent,
      isEnabled
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
      className: classes.hidden,
      type: "file",
      value: this.state.file,
      onChange: this.upload,
      id: "file_upload",
      name: "file_upload"
    }), isEnabled && /*#__PURE__*/React.createElement("label", {
      className: classnames(classes.link, {
        [classes.uploadAdditionalLink]: !isAttachmentPresent
      }),
      htmlFor: "file_upload"
    }, isAttachmentPresent ? 'Upload additional attachment' : 'Upload attachment'), isEnabled && /*#__PURE__*/React.createElement("span", {
      className: classes.info
    }, "Maximum file size *10 MB*. You can upload up to 3 attachments."));
  }
}
export default DesignAttachmentsForm;